import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Collapse } from 'antd';
import styles from './StickyCollapseList.module.scss';
import classNames from 'classnames';
import Link from 'next/link';
import {
  MenuItem,
  MenuListProps,
  CollapseListProps,
  CollapseItem
} from './StickyCollapseList.types';
import { useRouter } from 'next/router';
import { useLanguage } from '@/hooks/use-language';
import Image from 'next/image';

const MenuList: React.FC<MenuListProps> = ({ menuList, articleUrl }) => {
  const language = useLanguage();

  return (
    <>
      {menuList.map((item: MenuItem, index: number) => {
        return (
          <Link
            key={index}
            href={{
              pathname: `/${language}/blog/guide/${item.blog[0]?.url}`
            }}
            onClick={e => {
              window?.dataLayer?.push({
                event: 'buttonClick',
                buttonTitle: 'content_nav_article',
                description: item?.blog_title || item.blog[0]?.title,
                pageURL: window.location.href,
                componentName: 'content nav'
              });
            }}
          >
            <div
              className={classNames(
                styles.menu_item,
                `/${articleUrl}/` === item.blog[0]?.url && styles.active
              )}
            >
              {item.blog_title || item.blog[0]?.title}
            </div>
          </Link>
        );
      })}
    </>
  );
};

const CollapseList: React.FC<CollapseListProps> = props => {
  const {
    data: { title, url, table_of_content_entry: collapseList },
    isShow
  } = props;
  const router = useRouter();
  const language = useLanguage();
  // const introduction = router.query.introduction as string;
  const articleUrl = router.query.article as string;
  const [mobileActiveIndex, setMobileActiveIndex] = useState(-1);
  const [activeCollaspeIndex, setActiveCollaspeIndex] = useState(0);

  // 点击exoandIcon时正确冒泡，不跳到link事件
  const clickIcon = () => {};

  const expandSubCollapse = (e: string | any[]) => {
    if (e.length === 0) {
      setActiveCollaspeIndex(0);
    } else {
      // 展开对应章节
      setActiveCollaspeIndex(Number(e[1]));
    }
  };

  const expandMobileCollapse = (e: any) => {
    // 关闭状态
    if (e.length === 0) {
      setMobileActiveIndex(-1);
    } else {
      setMobileActiveIndex(0);
    }
  };

  useEffect(() => {
    // 根据article url 寻找当前的其父级目录
    const activeCollaspeIndex =
      collapseList.findIndex(item => {
        return item.blog_post.some(blogItem =>
          blogItem.blog.some(innerBlogItem => innerBlogItem?.url === `/${articleUrl}/`)
        );
      }) + 1;
    setActiveCollaspeIndex(activeCollaspeIndex);
    setMobileActiveIndex(-1);
  }, [articleUrl]);

  const items = collapseList?.map((item: CollapseItem, index: number) => ({
    key: index + 1,
    label: (
      <p
        className={styles.collapse_label}
        onClick={e => {
          window?.dataLayer?.push({
            event: 'buttonClick',
            buttonTitle: 'content_nav_article',
            description: item.category_title,
            pageURL: window.location.href,
            componentName: 'content nav'
          });
        }}
      >
        <span className={styles.collapse_label_index}>{index + 1}</span>
        <span>{item.category_title}</span>
      </p>
    ),
    children: <MenuList menuList={item.blog_post} articleUrl={articleUrl} />
  }));

  return (
    <>
      <div
        className={classNames(
          styles.sticky_collapse,
          // 两个show事件没有关系，满足任意一个即可show
          mobileActiveIndex === 0 && styles.show,
          isShow && styles.show
        )}
      >
        <Collapse
          ghost
          expandIconPosition={'end'}
          activeKey={mobileActiveIndex}
          expandIcon={({ isActive }) => (
            <div className={styles.mobile_collapse_icon_wrapper}>
              {/* 非active状态 */}
              {!isActive && (
                <Image
                  src="/blog/icon/Left.svg"
                  alt={''}
                  width={10}
                  height={6}
                  className={styles.collapse_icon_down}
                />
              )}
              {/* active状态 */}
              {isActive && (
                <Image
                  src="/blog/icon/ClosePrimary.svg"
                  alt={''}
                  width={15}
                  height={15}
                  className={styles.collapse_icon_up}
                />
              )}
            </div>
          )}
          items={[
            {
              key: 0,
              label: <div className={styles.collapse_title}>跳至其他章節</div>,
              children: (
                <div className={styles.expand_wrapper}>
                  <Link
                    href={{ pathname: `/${language}/blog/guide${url}` }}
                    onClick={e => {
                      window?.dataLayer?.push({
                        event: 'buttonClick',
                        buttonTitle: 'content_nav_article',
                        description: title,
                        pageURL: window.location.href,
                        componentName: 'content nav'
                      });
                    }}
                  >
                    <div
                      className={classNames(
                        styles.menu_item_all,
                        `/${articleUrl}/` === url && styles.active
                      )}
                    >
                      {title}
                    </div>
                  </Link>
                  <div className={styles.sub_callapse_wrapper}>
                    <Collapse
                      activeKey={activeCollaspeIndex}
                      ghost
                      items={items}
                      expandIconPosition={'end'}
                      expandIcon={({ isActive }) => (
                        <>
                          {isActive ? (
                            <Image
                              src="/blog/icon/Left.svg"
                              alt={''}
                              width={8}
                              height={4}
                              className={styles.collapse_icon_up}
                              onClick={() => clickIcon()}
                            />
                          ) : (
                            <Image
                              src="/blog/icon/Left.svg"
                              alt={''}
                              width={8}
                              height={4}
                              className={styles.collapse_icon_down}
                              onClick={() => clickIcon()}
                            />
                          )}
                        </>
                      )}
                      // 目录栏点击事件
                      onChange={e => expandSubCollapse(e)}
                    />
                  </div>
                </div>
              )
            }
          ]}
          onChange={e => expandMobileCollapse(e)}
        ></Collapse>
      </div>
    </>
  );
};

export default CollapseList;
